import { TableHeadDataProps } from "../../components/Table/TableHead";

// export const templateTableHeadData: TableHeadDataProps[] = [
//     { id: 0, title: '' },
//     { id: 1, title: 'Plan' },
//     { id: 2, title: 'Text' },
//     { id: 3, title: 'Type' },
//     { id: 4, title: 'SMS Send Mode' },
//     { id: 5, title: 'Status' },
//     { id: 6, title: 'Actions' },
//   ];

export const templateTableHeadData: TableHeadDataProps[] = [
  { id: 0, title: "" },
  { id: 1, title: "Category" },
  { id: 2, title: "Question" },
  { id: 3, title: "Answer Type" },
  { id: 4, title: "Dependent?" },
];
export const TemplateListHeadData: TableHeadDataProps[] = [
  { id: 0, title: "" ,value:""},
  { id: 1, title: "Template Name" ,value:"name" },
  { id: 2, title: "Type" ,value:"type"},
  { id: 3, title: "" ,value:""},
  { id: 4, title: "Category Count",value:'activeCategoryCount' },
  { id: 5, title: "" ,value:""},
  { id: 6, title: "Question Count",value:'activeQuestionCount' },
  { id: 7, title: "Status" ,value:'status'},
  { id: 8, title: "Action" },
];
